import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getPlayground(context) {
      let response = await Vue.axios.get(
        `${URL_API}architecture/getbytype?architecture_type_id=1`
      );
      let data = response["data"];
      context.commit("updatePlayground", data);
      return data;
    }
  },
  mutations: {
    updatePlayground(state, data) {
      state.playground = data;
    }
  },
  state: {
    playground: {}
  },
  getters: {
    allPlayground(state) {
      return state.playground;
    }
  }
};
